import React from 'react';
import { Path, Svg } from 'react-native-svg';
import type { IconProps } from './types';
import { Colors } from '../../../themes/colors';

/**
 * Muted microphone glyph — the `Microphone` shape with a strike-through line.
 * Shown on the in-call mic control when the local mic is off.
 */
export const MicrophoneMutedIcon: React.FC<IconProps> = ({
  size = 24,
  color = Colors.role.textStrong,
  style,
  ...props
}) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 24 26"
    fill="none"
    overflow="visible"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
    style={[{ overflow: 'visible' } as const, style] as unknown}
  >
    <Path
      d="M20.25 11.5V14.5C20.25 17.8137 17.5637 20.5 14.25 20.5L12 20.5H9.75C6.43629 20.5 3.75 17.8137 3.75 14.5V11.5M12 20.5V25M12 25H8.25M12 25H15.75M6.75 7V4C6.75 2.34314 8.09315 0.999999 9.75 1L14.25 1C15.9069 1 17.25 2.34315 17.25 4V7M17.25 11.5V14.5C17.25 16.1569 15.9069 17.5 14.25 17.5L9.75 17.5C8.09315 17.5 6.75 16.1569 6.75 14.5V11.5M24 9.25H0"
      stroke={color}
      strokeWidth="2"
    />
  </Svg>
);

MicrophoneMutedIcon.displayName = 'MicrophoneMutedIcon';
